const Erros: { [key: string]: string } = {
    Cpf: "Cpf é invalido.",
    Matricula:'A matricula é invalida',  
    domainEmail:'O Dominio do email é invalido.',
    null:'Houve um problema interno, Tente novamente mais tarde.'
}
export default Erros;